import { ServiceStore } from "@intrasync/stores";
import { RouteType } from "types/RouteType";

const NCRWizardRoute: RouteType = {
  name: "NCRWizard",
  path: "/workflows/ncr",
  layout: "/app",
  group: "Workflows",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Non-Conformance Report",
      component: () => import("./NCRWizardHeader"),
      enableRefreshButton: false,
      enableBackButton: true,
    },
    body: {
      component: () => import("./NCRWizard"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    try {
      const qcStore = rootStore.qcStore as ServiceStore;
      const panelStore = rootStore.panelStore as ServiceStore;
      const productsStore = rootStore.productsStore as ServiceStore;
      const jobStore = rootStore.jobStore as ServiceStore;
      const userStore = rootStore.userStore as ServiceStore;
      const holdStore = rootStore.holdStore as ServiceStore;

      await Promise.all([
        qcStore?.find(),
        panelStore?.find(),
        productsStore?.find(),
        jobStore?.find(),
        userStore?.find(),
      ]);

      return true;
    } catch (error) {
      console.error("Failed to load data for NCR:", error);
      return false;
    }
  },
};

export default NCRWizardRoute;